/* Display only. Shopify automatic discounts control checkout totals.
 * October 19, 2026 00:00 America/Los_Angeles = 07:00 UTC.
 * Refresh cached markup and pages left open across the cutoff. */
(function () {
  'use strict';
  if (document.querySelector('.rs-holiday-banner')) return;
  var cutoff = Date.parse('2026-10-19T07:00:00Z');
  var timer;
  function write(selector, value) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.textContent !== value) el.textContent = value;
    });
  }
  function refresh() {
    var ended = (window.rsLaunch ? window.rsLaunch.now() : Date.now()) >= cutoff;
    var price = ended ? '$66' : '$49';
    var percent = ended ? '25' : '44';
    write('[data-rs-otp-price]', price);
    write('[data-rs-otp-percent]', percent + '% OFF');
    write('[data-rs-otp-bag-label]', ended ? '1 BAG' : '1 TRIAL BAG');
    write('[data-rs-otp-banner]', 'Or try one bag for ' + price + ' + shipping');
    document.querySelectorAll('#redsalt-preset-bundle-form').forEach(function (form) {
      form.querySelectorAll('[name="otp_variant"]').forEach(function (input) {
        input.dataset.price = price + '.00';
      });
      var button = form.querySelector('.rs-submit--onetime');
      if (button && !button.disabled && button.textContent !== 'Try Again') {
        button.textContent = 'Try One Full Bag · ' + price + '.00';
      }
      var note = form.querySelector('.rs-otp-note');
      if (note) {
        var lead = '<strong>Try REDSALT for ' + price + '. Save ' + percent + '%.</strong> ';
        var offer = ended ? 'Get one full bag for $66 instead of $88.' : 'We know REDSALT may be new to you, so for a limited time you can try one full bag for $49 instead of $88.';
        note.innerHTML = lead + offer + ' No recurring charge. Shipping is calculated at checkout. Welcome gifts, locked member pricing and the 30-day membership guarantee apply only to memberships.';
      }
      var selected = form.querySelector('[name="otp_variant"]:checked');
      if (selected) selected.dispatchEvent(new Event('change', { bubbles: true }));
    });
    clearTimeout(timer);
    if (!ended) timer = setTimeout(refresh, Math.min(cutoff - Date.now() + 50, 3600000));
  }
  window.rsRefreshOtpPrice = refresh;
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();

